<template>
    <tbody class="white-bg" @keydown.esc="closeQr">
        <tr :id="'c-' + index" :class="{ gray: isEven }">
            <td class="td-icon">
                <span :class="'medical ' + [hasMedicalConditions ? 'active' : '']"></span>
                <span :class="'marketing ' + [session.customer.marketing == 1 ? 'active' : '']"></span>
                <span :class="'usb ' + [session.copy_usb == 1 ? 'active' : '']"></span>
            </td>
            <td v-text="sessionNumber"></td>
            <td v-text="customerName"></td>
            <activity :activity="session.bjf" :hasDropdown="false" ></activity>
            <activity :activity="session.bjs" :hasDropdown="false" ></activity>
            <activity :activity="session.sjf" :hasDropdown="false" ></activity>
            <activity :activity="session.sjs" :hasDropdown="false" ></activity>
            <activity :index="index" @group-number-changed="notifyStaff" :hasDropdown="true" :groupNumber="swGroupNumber" :activity="session.sw" ></activity>
            <activity :index="index" @group-number-changed="notifyStaff" :hasDropdown="true" :groupNumber="tcGroupNumber" :activity="session.tc" ></activity>
            <td style="text-align: center;"><a @click="toggleCustomerInfo" :class="'edit-customer ' + [isVisible ? 'close' : '']"></a></td>
        </tr>
        <tr v-if="isVisible">
            <td class="customer-info-wrap" colspan="12">
                <div class="customer-info sap">
                    <h2 v-show="isSaving" class="saving">Saving Changes...</h2>
                    <div class="details">
                        <div class="row align-items-center">
                            <div class="col-6">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <h3 v-text="customerName" class="customer-name"></h3>
                                    </div>
                                </div> 
                            </div>
                            <div class="col-6">
                                <div class="registration">
                                    <div v-if="session.customer.registered_staff" class="form-group left gray">
                                        <label>Created:</label>
                                        <span class="data" v-text="`${session.registerDate}  ${session.customer.registered_staff.username} / ${session.customer.registered_staff.firstname} ${session.customer.registered_staff.lastname}`"></span>
                                    </div>   
                                    <div v-if="session.customer.updated_staff" class="form-group left gray">
                                        <label>Last Modified</label>
                                        <span class="data" v-text="`${session.updatedDate} ${session.customer.updated_staff.username} / ${session.customer.updated_staff.firstname} ${session.customer.updated_staff.lastname}`"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row customer-activities">
                            <div class="col-6">
                                <div class="d-flex justify-content-between align-items-center session-and-qr top">
                                    <div class="cs-label d-flex">
                                        <label for="">Cust ID: </label>
                                        <div class="cs-value" v-text="session.customer.customer_number"></div>
                                    </div>
                                    <a :href="'/ap/cr/customer/' + session.customer.hashed" class="portal-qr">
                                        <img src="/images/admin/membercard.png" class="img-fluid" />
                                        <span>RECORD</span>
                                    </a> 
                                </div>
                                <div class="d-flex justify-content-between align-items-center session-and-qr">
                                    <div class="cs-label d-flex">
                                        <label for="">Session: </label>
                                        <div class="cs-value" v-text="sessionNumber"></div>
                                    </div>
                                    <button @click="generateQR" v-if="session.webportalLink" class="portal-qr">
                                        <img src="/images/admin/qr-placeholder.jpg" class="img-fluid" />
                                        <span>Portal</span>
                                    </button> 
                                </div>
                                <div class="customer-notification-info">
                                    <div v-if="session.customer.sms" class="cs-label margin-b d-flex">
                                        <label for="">Phone:</label>
                                        <div class="cs-value">{{ session.customer.phone }}</div>
                                    </div>
                                    <div class="form-group white d-flex cs-label">
                                        <label>Email:</label>
                                        <div style="width: 100%;">
                                            <div class="input-holder">
                                                <input ref="email_add" :disabled="!isEdited" @keyup="isSubmitted = false" @keydown="delete errors.email" :class="[errors.email ? 'has-error' : '']" type="email" name="email" v-model="session.customer.email" />
                                                <span class="error" v-if="errors.email" v-text="errors.email[0]"></span>
                                            </div>      
                                        </div>
                                    </div>
                                    <div v-if="!isEdited" class="actions no-border d-flex justify-content-end">
                                        <button type="submit" @click="updateEmail" class="submit gray" name="save" style="min-width: 83px;">Edit</button>
                                        <button :disabled="isSubmitted" type="submit" @click="updateAndSendNotification" class="submit" name="save-and-resend">Resend</button>
                                    </div>
                                    <div v-if="isEdited" class="actions no-border d-flex justify-content-end">
                                        <button type="submit" @click="updateCustomer" class="submit" name="save">Save</button>
                                        <button type="button" @click="cancelEmailUpdate" class="cancel" style="margin-left: 8px; font-weight: normal; min-width: 103px;">Cancel</button>
                                    </div>
                                </div>

                                <div class="medical-list" v-if="hasMedicalConditions">
                                    <p><strong>Medical Conditions:</strong></p>
                                    <ul>
                                        <li :index="index" v-for="(condition, index) in medicalCondtions" :key="index" v-text="condition"></li>
                                    </ul>
                                </div>
                                
                            </div>
                            <div class="col-6">
                                <div :class="'activities ' + [isSaving ? 'locked' : '']">
                                    <activityChange
                                        v-if="!activityChangeSubmitted" 
                                        :activity1="tempSession.bjf" 
                                        :activity2="tempSession.bjs" 
                                        :activityName="'Bungy'" 
                                        :switchOnLabel="'BJS'" 
                                        :switchOffLabel="'BJF'"
                                        :hasSwitch="true"
                                        :source="'bj'"
                                        @activityHasUpdated="inlistActivity"
                                    ></activityChange>
                                    <activityChange
                                        v-if="!activityChangeSubmitted"  
                                        :activity1="tempSession.sjf" 
                                        :activity2="tempSession.sjs" 
                                        :activityName="'Skyjump'" 
                                        :switchOnLabel="'SJS'" 
                                        :switchOffLabel="'SJF'"
                                        :hasSwitch="true"
                                        :source="'sj'"
                                        @activityHasUpdated="inlistActivity"
                                    ></activityChange>
                                    <activityChange
                                        v-if="!activityChangeSubmitted"  
                                        :activity1="tempSession.sw" 
                                        :activity2="null" 
                                        :activityName="'Skywalk'" 
                                        :switchOnLabel="''" 
                                        :switchOffLabel="'SW'"
                                        :hasSwitch="false"
                                        :parent="(tempSession.sw) ? tempSession.sw.parent : null"
                                        :source="'sw'"
                                        @activityHasUpdated="inlistActivity"
                                    ></activityChange>
                                    <activityChange
                                        v-if="!activityChangeSubmitted"  
                                        :activity1="tempSession.tc" 
                                        :activity2="null" 
                                        :activityName="'Tower Climb'" 
                                        :switchOnLabel="''" 
                                        :switchOffLabel="'TC'"
                                        :hasSwitch="false"
                                        :parent="(tempSession.tc) ? tempSession.tc.parent : null"
                                        :source="'tc'"
                                        @activityHasUpdated="inlistActivity"
                                    ></activityChange>
                                    <div class="actions no-border red-button">
                                        <button :disabled="!activityHasChanges" @click="doActivityChange" type="submit" class="submit">Save activity Changes</button>
                                        <button v-if="activityHasChanges" type="button" @click="cancelActivityChange" class="cancel">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div :class="'qr-code-wrapper ' + [qrOpen ? 'open' : '']">
                        <a href="javascript:void(0);" class="close-button-qr" @click="qrOpen = !qrOpen"></a>
                        <img :src="customerQR" class="img-fluid" />
                        <a class="customer-link-qr" v-if="session.webportalLink" target="_blank" :href="session.webportalLink">Customer Link</a>
                    </div>
                    <div :class="'qr-code-wrapper ' + [customerQROpen ? 'open' : '']">
                        <a href="javascript:void(0);" class="close-button-qr" @click="customerQROpen = !customerQROpen"></a>
                        <img :src="customerIDQR" class="img-fluid" />
                    </div>
                    <div v-if="show_nfc_column" class="nfc-column">
                        <div class="details">
                            <div class="d-flex justify-content-between align-items-center session-and-qr">
                                <div class="cs-label d-flex">
                                    <label for="">NFC ID: </label>
                                    <div class="cs-value" v-text="session.nfc_id"></div>
                                </div>
                                <button @click="generateCustomerIDQR()" class="portal-qr">
                                    <img src="/images/admin/qr-placeholder.jpg" class="img-fluid" />
                                    <span>Customer QR</span>
                                </button> 
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</template>

<script>
    import activity from './ActivityComponent';
    import activityChange from './ActivityChangeComponent'
    import {mapActions, mapState} from 'vuex';
    import QRCode from 'qrcode';

    export default {
        props: ['session', 'index', 'groupNumber', 'show_nfc_column'],
        components: {
            activity,
            activityChange
        },
        data() {
            return {
                isVisible: false,
                errors: [],
                isSubmitted: false,
                activityHasChanges: false,
                activityToChange: {},
                activityChangeSubmitted: false,
                isSaving: false,
                qrOpen: false,
                customerQROpen: false,
                customerQR: '',
                customerIDQR: '',
                isEdited: false,
                componentKey: 0,
                tempSession: JSON.parse(JSON.stringify(this.session)),
            }
        },
        computed: {
            ...mapState(['swGroupNumber', 'tcGroupNumber']),
            customerName() {
                if(!this.session.customer.firstname && !this.session.customer.lastname) {
                    return this.session.customer.chinese_name;
                }
                
                return this.session.customer.firstname + " " + this.session.customer.lastname;
            },
            sessionNumber() {
                return this.session.session_number.split("-")[1];
            },
            isEven() {
                return (this.index % 2 == 0);
            },
            medicalCondtions() {
                let conditions = [];

                for (var key of Object.keys(this.session.unserializeMedical)) {
                    if(this.session.unserializeMedical[key] != null && this.session.unserializeMedical[key] != 'None of the above') {
                        conditions.push(this.session.unserializeMedical[key]);
                    }
                }

                return conditions;
            },
            hasMedicalConditions() {
                let hasCondition = false;

                for (var key of Object.keys(this.session.unserializeMedical)) {
                    if(this.session.unserializeMedical[key] != null && this.session.unserializeMedical[key] != 'None of the above') {
                        hasCondition = true;
                    }
                }

                return hasCondition;
            }
        },
        methods: {
            toggleCustomerInfo() {
                if(this.isVisible) {
                    this.activityChangeSubmitted = true;
                } else {
                    this.activityChangeSubmitted = false;
                }
                this.isVisible = !this.isVisible;
                this.isSaving = false;
                this.qrOpen = false;
                this.customerQROpen = false;
            },
            cancelActivityChange() {
                this.activityChangeSubmitted = true;
                this.isVisible = !this.isVisible;
                this.isSaving = false;
                this.activityHasChanges = false;
                this.tempSession = JSON.parse(JSON.stringify(this.session));
            },
            async updateCustomer() {
                // this.isSubmitted = true;

                await axios.post('/ap/customer/update', this.session)
                    .then(({data}) => {
                        this.session.customer.updated_staff = data;
                        this.session.customer.last_date_updated = data.last_updated_date;
                        console.log(this.session.customer.last_updated_date);
                        toastr.success("Customer: " + this.customerName + " was successfully updated.");
                        this.isEdited = false;
                    })
                    .catch(error => this.errors = error.response.data.errors);
            },
            async updateAndSendNotification() {
                this.isSubmitted = true;

                await axios.post('/ap/customer/update-and-resend', this.session)
                    .then(({data}) => {
                        this.session.customer.updated_staff = data;
                        this.session.customer.last_date_updated = data.last_updated_date;
                        toastr.success("Customer: " + this.customerName + " was successfully re-send notification");
                        this.isEdited = false;
                    })
                    .catch(error => this.errors = error.response.data.errors);
            },
            notifyStaff(groupNumber) {
                toastr.success("Customer: " + this.customerName + " is assigned to group " + groupNumber + ".");
            },
            inlistActivity(activity) {
                if(activity.source == 'bj') {
                    this.activityToChange.bj = activity;
                } else if(activity.source == 'sj') {
                    this.activityToChange.sj = activity;
                } else if(activity.source == 'sw') {
                    this.activityToChange.sw = activity;
                } else if(activity.source == 'tc') {
                    this.activityToChange.tc = activity;
                }
                
                this.activityHasChanges = true;
            },
            doActivityChange() {
                this.activityHasChanges = false;
                this.isSaving = true;

                axios.post('/ap/customer/change-activities/' + this.session.id, {activities: this.activityToChange})
                .then(({data}) => {
                    setTimeout(() => {
                        this.$store.commit('setSessions', data);
                        this.activityToChange = {};
                        this.tempSession = JSON.parse(JSON.stringify(data.filter(x => x.id === this.session.id)[0]));
                        toastr.success("Customer: " + this.customerName + " activities was successfully changed.");
                        this.activityChangeSubmitted = true;
                        this.isVisible = !this.isVisible;
                    }, 2000);
                })
                .catch(error => this.errors = error.response.data.errors);
            },
            async generateQR() {
                const opts = {
                    color: {
                        dark:"#000",
                        light:"#fff"
                    },
                    width: 500
                }
                try {
                    const qr = await QRCode.toDataURL(this.session.webportalLink, opts);
                    this.customerQR = qr;
                    this.qrOpen = true;
                } catch (err) {
                    console.error(err)
                }

                return;
            },
            async generateCustomerIDQR() {
                const opts = {
                    color: {
                        dark:"#000",
                        light:"#fff"
                    },
                    width: 500
                }
                try {
                    const qr = await QRCode.toDataURL(this.session.customer.hashed, opts);
                    this.customerIDQR = qr;
                    this.customerQROpen = true;
                } catch (err) {
                    console.error(err)
                }

                return;
            },
            updateEmail() {
                this.isEdited = true;
                this.$refs.email_add.focus();
            },
            cancelEmailUpdate() {
                this.isEdited = false;
            },
            getTime(date) {
                if(date) {
                    const lastUpdated = new Date(date);

                    return lastUpdated.getHours() + ":" + lastUpdated.getMinutes().toString().padStart(2, 0);
                }

                return;
                
            },
            closeQr() {
                this.qrOpen = false;
                this.customerQROpen = false;
            }
        },
        mounted() {
            
        }
    }
</script>

<style lang="scss">
    .close-button-qr {
        position: absolute;
        top: 60px;
        right: 60px;
        background: transparent;
        border: none;
        outline: none;
        width: 25px;
        height: 25px;
        cursor: pointer;

        &:before, &:after {
            content: "";
            height: 3px;
            width: 25px;
            background: #000;
            display: block;
        }

        &:before {
                transform: rotate(45deg) translate(2px, 2px);
        }

        &:after {
            transform: rotate(-45deg);
        }
    }
</style>
